import React, { Component } from "react";
import { Box } from "@material-ui/core";
import classes from "./Subscription.module.css";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import FavoriteIcon from "@material-ui/icons/Favorite";
import IconButton from "@material-ui/core/IconButton";

import LinkedInIcon from "@material-ui/icons/LinkedIn";
import FacebookIcon from "@material-ui/icons/Facebook";
import EmailIcon from "@material-ui/icons/Email";
import InstagramIcon from "@material-ui/icons/Instagram";
import Grid from "@material-ui/core/Grid";
import resume from "../../asset/YidiWang2022.pdf";
import * as firebase from "firebase";

class Subscription extends Component {
  constructor() {
    super();
    this.state = {
      likeNum: 0,
      clickable: true,
    };
  }

  componentDidMount() {
    const rootRef = firebase.database().ref().child("/like");
    rootRef.once("value").then((snap) => {
      this.setState({ likeNum: snap.val() });
    });
    rootRef.on("value", (snap) => {
      this.setState({
        likeNum: snap.val(),
      });
    });
  }

  likeClickHandler = (event) => {
    firebase
      .database()
      .ref("/like")
      .transaction((cur) => cur + 1);

    this.setState({
      clickable: false,
    });
  };
  render() {
    return (
      <Box className={classes.block}>
        <Box mx={4} mt={2} className={classes.center}>
          <Box className={classes.center}>
            <IconButton
              color="secondary"
              aria-label="Like"
              onClick={this.state.clickable ? this.likeClickHandler : null}
            >
              {this.state.clickable ? <FavoriteBorderIcon /> : <FavoriteIcon />}
            </IconButton>
            <span style={{ color: "white" }}>{this.state.likeNum}</span>
          </Box>
        </Box>

        <Box  style={{ color: "white",textAlign:"center"}}>
          <span>
            You are welcome to shoot me messages via linkedIn or email! Check
            out{"    "}
            <a href={resume} target="new" className={classes.resume}>
              {" "}
              My Resume
            </a>{" "}
          </span>
        </Box>
        <Box mt={3} pb={3}>
          <Grid container>
            <Grid item xs={3} className={classes.center}>
              <a href="mailto:yw73@rice.edu">
                <EmailIcon style={{ color: "white", fontSize: "60px" }} />
              </a>
            </Grid>
            <Grid item xs={3} className={classes.center}>
              <a href="https://www.facebook.com/yidi.wang.5891">
                <FacebookIcon
                  style={{ color: "rgb(59, 90, 154)", fontSize: "60px" }}
                />
              </a>
            </Grid>
            <Grid item xs={3} className={classes.center}>
              <a href="https://www.instagram.com/yidiiiiiiiiiii/?hl=en">
                <InstagramIcon
                  style={{
                    background:
                      "radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%)",
                    color: "white",
                    fontSize: "46px",
                    borderRadius: "7px",
                  }}
                />
              </a>
            </Grid>
            <Grid item xs={3} className={classes.center}>
              <a href="https://www.linkedin.com/in/yidi-wang-364423184/">
                <LinkedInIcon
                  style={{ color: "rgb(0, 123, 181)", fontSize: "60px" }}
                />
              </a>
            </Grid>
          </Grid>
        </Box>
      </Box>
    );
  }
}

export default Subscription;
